import './App.css';
import * as React from 'react';
import { useState, useEffect, createContext, useContext } from 'react';
import { ReactLoader } from './common/custom-loader/custom-loader'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HelpDeskModuleRouter from './routes';
import ThemeProvider from './common/common-sidebar/theme';
import { onSignOut } from './common/Utils';
import jwt from 'jwt-decode';
import { authorizeCode } from './registration/screens/registration/commonRegistrationStakeholderAPIs';
import { reactPlugin } from "./AppInsights";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import DisablePrint from './common/disablePrintAccess';
import WatermarkOverlay from './common/watermarkOverlay';

const DataContext = createContext();
export const UserContext = React.createContext({
    guestUser: null,
});

function App() {
    const checkTst = process.env.REACT_APP_ENV === "test" || process.env.REACT_APP_ENV === "test local"
    const idToken = localStorage.getItem('id_token');
    const [email, setEmail] = useState("");
    const [URN, setURN] = useState("");
    const [sideBarData, setSideBarData] = useState([]);
    const [guestUser, setGuestUser] = useState(null);
    const [loginUserDetails, setLoginUserDetails] = useState({
        adb2c_oid: '',
        userName: '',
        email: '',
        urn: '',
        stakeholderType: '',
        userId: ''
    });
    const [lastActivityTime, setLastActivityTime] = useState(Date.now());
    const [inactivityThreshold, setInactivityThreshold] = useState(300000);
    const addGuestUser = (data) => {
        setGuestUser(data);
    };

    if (!idToken) {
        const urlSearchParams = new URLSearchParams(window.location.search.substring(1));
        const codeFromURL = urlSearchParams.get('code')
        if (codeFromURL) {
            localStorage.setItem('auth_code', codeFromURL);
            var policy = urlSearchParams.get('state');
            localStorage.setItem('policy', policy);
        }
    }

    // useEffect(() => {
    //     const activityHandler = () => {
    //         setLastActivityTime(Date.now());
    //     };
    //     const interval = setInterval(() => {
    //         if (localStorage.getItem('loginStatus') == "true") {
    //             if (idToken != null && idToken != undefined && idToken != "undefined") {
    //                 window.addEventListener('mousemove', activityHandler);
    //                 window.addEventListener('keydown', activityHandler);
    //                 const decoded = jwt(idToken);
    //                 const currentTime = Date.now();
    //                 if ((currentTime - lastActivityTime) + 60000 >= inactivityThreshold) { //calling the API 60 seconds before token expiry
    //                     onSignOut();
    //                 }
    //                 else if (decoded.exp <= Math.floor(new Date().getTime() / 1000.0)) {
    //                     authorizeCode(null, localStorage.getItem('refresh_token'), setInactivityThreshold, setLastActivityTime, setEmail);
    //                 }
    //             }
    //             else {
    //                 onSignOut();
    //             }
    //         }
    //         else if ((localStorage.getItem('loginStatus') == "false" || !localStorage.getItem('loginStatus')) && window.location.pathname != '/' && !localStorage.getItem('auth_code')) {
    //             onSignOut();
    //         }
    //     }, 500)
    //     return () => {
    //         window.removeEventListener('mousemove', activityHandler);
    //         window.removeEventListener('keydown', activityHandler);
    //         clearInterval(interval)
    //     }
    // }, [lastActivityTime])

    useEffect(() => {
  const activityHandler = () => {
    setLastActivityTime(Date.now());
  };

  // Add listeners once per effect lifecycle
  window.addEventListener('mousemove', activityHandler);
  window.addEventListener('keydown', activityHandler);

  const REFRESH_EARLY_MS = 60_000;

  // Utility: consider "", "undefined", "null", or missing dots as invalid JWT
  const isLikelyValidJwt = (tok) => {
    if (typeof tok !== 'string') return false;
    const t = tok.trim();
    if (!t) return false;
    const lc = t.toLowerCase();
    if (lc === 'undefined' || lc === 'null') return false;
    // Must be header.payload.signature => two dots
    const dotCount = (t.match(/\./g) || []).length;
    return dotCount === 2;
  };

  const interval = setInterval(() => {
    const loginStatus = localStorage.getItem('loginStatus'); // "true" | "false" | null

    if (loginStatus === "true") {
      // Always read the latest token from storage
      const tokenRawFromStorage = localStorage.getItem('id_token');
      const token = typeof tokenRawFromStorage === 'string' ? tokenRawFromStorage.trim() : '';

      //  If idToken not found or invalid, sign out immediately
      if (!isLikelyValidJwt(token)) {
        onSignOut();
        return;
      }

      // Safe decode (never let this crash)
      let decoded;
      try {
        decoded = jwt(token);
      } catch (e) {
        console.warn('JWT decode failed, signing out:', e);
        onSignOut();
        return;
      }
      if (!decoded || typeof decoded.exp !== 'number') {
        onSignOut();
        return;
      }

      // Token timing
      const now = Date.now();
      const msUntilExpiry = decoded.exp * 1000 - now;

      if (msUntilExpiry <= 0) {
        // Token expired
        authorizeCode(
          null,
          localStorage.getItem('refresh_token'),
          setInactivityThreshold,
          setLastActivityTime,
          setEmail
        );
        return;
      } else if (msUntilExpiry <= REFRESH_EARLY_MS) {
        // Refresh 60s before expiry
        authorizeCode(
          null,
          localStorage.getItem('refresh_token'),
          setInactivityThreshold,
          setLastActivityTime,
          setEmail
        );
        return;
      }

      // Inactivity check
      const last = typeof lastActivityTime === 'number' ? lastActivityTime : 0;
      const msSinceLast = now - last;
      if (
        typeof inactivityThreshold === 'number' &&
        inactivityThreshold > 0 &&
        msSinceLast >= inactivityThreshold
      ) {
        onSignOut();
        return;
      }

    } else if (
      (loginStatus === "false" || !loginStatus) &&
      window.location.pathname !== '/' &&
      !localStorage.getItem('auth_code')
    ) {
      onSignOut();
    }
  }, 500);

  return () => {
    window.removeEventListener('mousemove', activityHandler);
    window.removeEventListener('keydown', activityHandler);
    clearInterval(interval);
  };

}, [lastActivityTime, inactivityThreshold, setLastActivityTime, setInactivityThreshold, setEmail]);

    const handleChange = (e) => {
        if (e.target.type == "text" || e.target.type == "textarea") {
            const pointer = e.target.selectionStart;
            const element = e.target;
            window.requestAnimationFrame(() => {
                element.selectionStart = pointer;
                element.selectionEnd = pointer;
            });
            e.target.value = e.target.value.toUpperCase();
        }
    }

    // useEffect(() => {
    //     const enable = () => document.body.classList.add("allow-print");
    //     const disable = () => document.body.classList.remove("allow-print");

    //     // When browser starts printing
    //     window.addEventListener("beforeprint", enable);

    //     // After printing
    //     window.addEventListener("afterprint", disable);

    //     // Wrap window.print
    //     const originalPrint = window.print;
    //     window.print = (...args) => {
    //         enable();
    //         setTimeout(() => originalPrint.apply(window, args), 50);
    //     };

    //     return () => {
    //         window.removeEventListener("beforeprint", enable);
    //         window.removeEventListener("afterprint", disable);
    //         window.print = originalPrint;
    //         disable();
    //     };
    // }, []);

    // useEffect(() => {
    //     document.body.classList.add("app-shell");
    // }, []);

    return (
        <AppInsightsErrorBoundary onError={() => <h1>I believe something went wrong</h1>} appInsights={reactPlugin}>
            <DataContext.Provider value={{ sideBarData, setSideBarData, email, URN, setEmail, setInactivityThreshold, setLastActivityTime, loginUserDetails, setLoginUserDetails }}>
                <div className="App" onChangeCapture={(e) => handleChange(e)}>
                    {
                        checkTst &&
                        <>
                            <DisablePrint />
                            <WatermarkOverlay />
                        </>
                    }
                    <UserContext.Provider value={{
                        guestUser, addGuestUser
                    }}>
                        <ReactLoader visibleCount={0} />
                        <ToastContainer autoClose={10000} />
                        <ThemeProvider>
                            <HelpDeskModuleRouter />
                        </ThemeProvider>
                    </UserContext.Provider>
                </div>
            </DataContext.Provider>
        </AppInsightsErrorBoundary>
    );
}

export default App;
export const useData = () => useContext(DataContext)